import { createStore } from 'jotai';

const GlobalStore = createStore();

export default GlobalStore;
